export default __webpack_public_path__ + "aaf8be8c258ba598767f687be754e96d.png";